import React, { Component } from 'react';
import PropTypes from 'prop-types';
import WBottomBtnsBar from '../WBottomBtnsBar';
import { v4 as uuidv4 } from 'uuid';
import AWS from 'aws-sdk';

class WUploadDocumentsStep extends Component {
  constructor(props) {
    super(props);

    const { text, identityPoolId, region } = props.options[0].options;
    this.state = {
      files: [],
      text: text,
      uploading: false,
      bucketName: '',
    };

    // Initialize the Amazon Cognito credentials provider
    AWS.config.region = region; // Region
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({
      IdentityPoolId: identityPoolId,
    });

    this.fileInputRef = React.createRef();
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.deleteFile = this.deleteFile.bind(this);
  }

  componentDidMount() {
    fetch('/env.json')
      .then((response) => response.json())
      .then((data) => {
        this.setState({ bucketName: data.bucket });
      })
      .catch((error) => {
        console.error('Error fetching bucket name:', error);
      });
  }

  handleFileUpload() {
    this.setState({ uploading: true });
    const files = this.fileInputRef.current.files;
    const s3 = new AWS.S3();
    const bucketName = this.state.bucketName;

    const uploadPromises = Array.from(files).map((file) => {
      const key = uuidv4() + '-' + file.name;

      const params = {
        Bucket: bucketName,
        Key: key,
        ContentType: file.type,
        Body: file,
      };

      return new Promise((resolve, reject) => {
        s3.upload(params, (err, data) => {
          if (err) {
            console.error('Error uploading the file to S3:', err);
            reject(err);
          } else {
            console.log('File uploaded successfully:', data);
            this.setState((prevState) => ({ files: [...prevState.files, data] }));
            resolve(data);
          }
        });
      });
    });

    Promise.all(uploadPromises)
      .then(() => this.setState({ uploading: false }))
      .catch(() => this.setState({ uploading: false }));

    // Clear the file input
    this.fileInputRef.current.value = '';
  }

  deleteFile(index) {
    this.setState((prevState) => {
      const files = [...prevState.files];
      files.splice(index, 1);
      return { files };
    });
  }

  render() {
    const { options: [options], onNext, fieldName, onBack } = this.props;
    return (
      <div className={'wui step-input'}>
        <div className={'wui step-input paper'}>
          <div className={'wui step-input-img-container'}>
            {this.state.uploading ? (
              <div className="loading-symbol">
                {/* Replace this with your loading symbol */}
                <img height="50px" src={`${process.env.PUBLIC_URL}${options.options.loader}`} alt="Loading..." />
              </div>
            ) : this.state.files.length > 0 ? (
                <div className="uploaded-files-container">
                  <ul className="no-bullet">
                    {this.state.files.map((file, index) => (
                      <li key={index}>
                        <button onClick={() => this.deleteFile(index)}>
                          Löschen
                        </button>
                        {generateDisplayString(file.key || file['Key'])}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <img
                  src={`${process.env.PUBLIC_URL}${options.options.icon}`}
                  alt={''}
                  className={'wui step-input-image'}
                />
              )
            }

          </div>
          <div className={'wui step-input-btn-container'}>
            <div className={'wui step-input-header'}>{options.options.text}</div>
            <div className={'wui step-input-styled'}>
              <input
                className={'wui step-input-styled-input'}
                type={'file'}
                multiple
                ref={this.fileInputRef}
                onChange={this.handleFileUpload}
              />
              <div className={'wui step-input-desc'}>{options.options.description}</div>
            </div>
            <button
              type={'submit'}
              className={'wui action-button device-desktop'}
              disabled={false}
              onClick={() => {
                onNext && onNext({ value: this.state.files, next: options.next, fieldName });
              }}
            >
              {options.options.button_title}
              <span className={'wui action-button-arrow'} />
            </button>
          </div>
        </div>

        <WBottomBtnsBar
          onBack={() => onBack && onBack()}
          nextBtnTitle={options.options.button_title}
          btnProps={{
            onClick: () => onNext && onNext({ value: this.state.files, next: options.next, fieldName }),
            disabled: this.state.files.length === 0,
          }}
        />
      </div>
    );
  }
}

function generateDisplayString(input='Datei') {
  const maxLength = 19;
  const length = input.length;

  if (length <= maxLength) {
    return input;
  } else {
    const halfLength = Math.floor(maxLength / 2);
    const firstHalf = input.slice(0, halfLength);
    const secondHalf = input.slice(length - halfLength, length);
    return firstHalf + '...' + secondHalf;
  }
}

WUploadDocumentsStep.propTypes = {
  type: PropTypes.oneOf(['upload-documents-step']).isRequired,
  onNext: PropTypes.func,
  onBack: PropTypes.func,
};

export default WUploadDocumentsStep;
